/* src/app/documents/document-upload/document-upload.component.scss */
.document-upload-page {
  min-height: 100vh;
  padding: 28px;
  background: #f5f7fb;
}
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 28px;
}
.page-header__eyebrow {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 7px;
  font-size: 12px;
  font-weight: 700;
  color: #253b80;
  text-transform: uppercase;
  letter-spacing: 0.7px;
}
.page-header h2 {
  margin: 0;
  color: #172033;
  font-size: 26px;
  font-weight: 700;
}
.page-header p {
  margin: 7px 0 0;
  color: #667085;
  font-size: 14px;
}
.workflow-stepper {
  position: relative;
  display: flex;
  align-items: flex-start;
  padding: 22px 26px;
  margin-bottom: 22px;
  background: #ffffff;
  border: 1px solid #e4e7ec;
  border-radius: 14px;
  box-shadow: 0 8px 30px rgba(16, 24, 40, 0.07);
}
.step {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}
.step__icon {
  position: relative;
  z-index: 2;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 2px solid #d0d5dd;
  border-radius: 50%;
  background: #f9fafb;
  color: #98a2b3;
  font-size: 16px;
  transition: 0.25s ease;
}
.step__content {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  min-width: 0;
}
.step__number {
  color: #98a2b3;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
}
.step__title {
  margin-top: 2px;
  color: #475467;
  font-size: 13px;
  font-weight: 700;
}
.step__description {
  margin-top: 2px;
  color: #667085;
  font-size: 11px;
  white-space: nowrap;
}
.step__line {
  flex: 1;
  height: 2px;
  margin: 0 18px;
  background: #eaecf0;
}
.step.active .step__icon {
  border-color: #253b80;
  background: #253b80;
  color: #ffffff;
  box-shadow: 0 0 0 5px rgba(37, 59, 128, 0.08);
}
.step.active .step__number,
.step.active .step__title {
  color: #253b80;
}
.step.completed .step__icon {
  border-color: #16a34a;
  background: #16a34a;
  color: #ffffff;
}
.step.completed .step__number,
.step.completed .step__title {
  color: #16a34a;
}
.step.completed .step__line {
  background: #16a34a;
}
.workflow-card {
  min-height: 520px;
  padding: 30px;
  background: #ffffff;
  border: 1px solid #e4e7ec;
  border-radius: 14px;
  box-shadow: 0 8px 30px rgba(16, 24, 40, 0.07);
}
.section-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding-bottom: 24px;
  border-bottom: 1px solid #f0f2f5;
}
.section-header__icon {
  width: 46px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 19px;
}
.section-header__icon.document {
  background: #eef2ff;
  color: #4338ca;
}
.section-header__icon.assessment {
  background: #eff6ff;
  color: #2563eb;
}
.section-header__icon.survey {
  background: #f5f3ff;
  color: #7c3aed;
}
.section-header__icon.poll {
  background: #ecfdf3;
  color: #16a34a;
}
.section-header__icon.note {
  background: #fff7ed;
  color: #ea580c;
}
.section-header h3 {
  margin: 0;
  color: #172033;
  font-size: 19px;
  font-weight: 700;
}
.section-header p {
  margin: 5px 0 0;
  color: #667085;
  font-size: 13px;
}
.upload-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 240px;
  margin-top: 26px;
  padding: 5px;
  border: 2px dashed #d0d5dd;
  border-radius: 14px;
  background: #fcfcfd;
  text-align: center;
  cursor: pointer;
  transition: 0.2s ease;
}
.upload-box:hover {
  border-color: #253b80;
  background: #f8faff;
}
.upload-box.has-file {
  border-color: #16a34a;
  background: #f8fffb;
}
.upload-box__icon {
  width: 62px;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
  border-radius: 50%;
  background: #eef2ff;
  color: #253b80;
  font-size: 25px;
}
.upload-box__icon.success {
  background: #ecfdf3;
  color: #16a34a;
}
.upload-box h4 {
  margin: 0;
  color: #172033;
  font-size: 16px;
  font-weight: 700;
}
.upload-box p {
  margin: 8px 0;
  color: #667085;
  font-size: 13px;
}
.upload-box p span {
  color: #253b80;
  font-weight: 600;
}
.upload-box small {
  color: #98a2b3;
  font-size: 11px;
}
.selected-file {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
  padding: 13px 15px;
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  background: #fafafa;
}
.selected-file__left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.selected-file__left .file-icon {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 8px;
  background: #eef2ff;
  color: #253b80;
}
.selected-file__left div:last-child {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.selected-file__left strong {
  max-width: 500px;
  overflow: hidden;
  color: #172033;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.selected-file__left span {
  margin-top: 3px;
  color: #667085;
  font-size: 11px;
}
.upload-progress {
  margin-top: 18px;
}
.upload-progress__header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 7px;
  color: #475467;
  font-size: 12px;
}
.upload-progress__header strong {
  color: #253b80;
}
.progress {
  height: 7px;
  overflow: hidden;
  border-radius: 10px;
  background: #eaecf0;
}
.progress__bar {
  height: 100%;
  border-radius: inherit;
  background: #253b80;
  transition: width 0.3s ease;
}
.action-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-top: 25px;
  padding-top: 20px;
  border-top: 1px solid #f0f2f5;
}
.action-footer__hint {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #667085;
  font-size: 12px;
}
.action-footer__hint i {
  color: #253b80;
}
.btn {
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 17px;
  border: 0;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
}
.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn-primary {
  background: #253b80;
  color: #ffffff;
}
.btn-primary:hover:not(:disabled) {
  background: #1d2f68;
}
.btn-success {
  background: #16a34a;
  color: #ffffff;
}
.btn-light {
  background: #f2f4f7;
  color: #475467;
}
.btn-light:hover {
  background: #e4e7ec;
}
.icon-button {
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  background: #f2f4f7;
  color: #475467;
  cursor: pointer;
  transition: 0.2s;
}
.icon-button:hover {
  background: #e4e7ec;
}
.icon-button.danger {
  color: #dc2626;
}
.icon-button.danger:hover {
  background: #fef2f2;
}
.empty-step {
  min-height: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.empty-step__icon {
  width: 74px;
  height: 74px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  border-radius: 50%;
  background: #f2f4f7;
  color: #253b80;
  font-size: 28px;
}
.empty-step h3 {
  margin: 0;
  color: #172033;
  font-size: 20px;
}
.empty-step p {
  max-width: 420px;
  margin: 8px 0 22px;
  color: #667085;
  font-size: 13px;
}
.note-editor {
  margin-top: 25px;
}
.note-editor label {
  display: block;
  margin-bottom: 8px;
  color: #172033;
  font-size: 13px;
  font-weight: 600;
}
.note-editor textarea {
  width: 100%;
  min-height: 220px;
  padding: 14px;
  resize: vertical;
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  outline: none;
  color: #172033;
  font-size: 13px;
}
.note-editor textarea:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.08);
}
.modal-backdrop {
  position: fixed;
  z-index: 1000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(16, 24, 40, 0.55);
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
}
.document-editor {
  width: min(900px, 100%);
  overflow: hidden;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 24px 70px rgba(16, 24, 40, 0.2);
}
.document-editor__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 22px;
  border-bottom: 1px solid #e4e7ec;
}
.document-editor__header h3 {
  margin: 4px 0 0;
  color: #172033;
  font-size: 18px;
}
.document-editor__header .editor-label {
  color: #253b80;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.7px;
}
.document-editor__body {
  padding: 18px;
}
.document-editor__footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px 20px;
  border-top: 1px solid #e4e7ec;
  background: #fafafa;
}
.editor-toolbar {
  display: flex;
  gap: 5px;
  padding: 7px;
  border: 1px solid #e4e7ec;
  border-bottom: 0;
  border-radius: 9px 9px 0 0;
  background: #f9fafb;
}
.editor-toolbar button {
  width: 34px;
  height: 32px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #475467;
  cursor: pointer;
}
.editor-toolbar button:hover {
  background: #e4e7ec;
}
.document-content {
  width: 100%;
  min-height: 380px;
  display: block;
  padding: 16px;
  resize: vertical;
  border: 1px solid #e4e7ec;
  border-radius: 0 0 9px 9px;
  outline: none;
  color: #172033;
  font-size: 13px;
  line-height: 1.7;
}
.document-content:focus {
  border-color: #253b80;
}
.confirm-dialog {
  width: min(440px, 100%);
  padding: 32px;
  border-radius: 16px;
  background: #ffffff;
  text-align: center;
  box-shadow: 0 24px 70px rgba(16, 24, 40, 0.2);
}
.confirm-dialog__icon {
  width: 58px;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 17px;
  border-radius: 50%;
  background: #ecfdf3;
  color: #16a34a;
  font-size: 22px;
}
.confirm-dialog h3 {
  margin: 0;
  color: #172033;
  font-size: 20px;
}
.confirm-dialog p {
  margin: 10px auto 24px;
  color: #667085;
  font-size: 13px;
  line-height: 1.6;
}
.confirm-dialog__actions {
  display: flex;
  justify-content: center;
  gap: 10px;
}
.confirm-dialog__actions .btn {
  flex: 1;
}
@media (max-width: 900px) {
  .document-upload-page {
    padding: 18px;
  }
  .workflow-stepper {
    overflow-x: auto;
    padding: 18px;
  }
  .step {
    min-width: 180px;
  }
  .step__line {
    min-width: 30px;
  }
  .workflow-card {
    padding: 20px;
  }
}
@media (max-width: 600px) {
  .page-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .workflow-stepper {
    padding: 15px;
  }
  .step {
    min-width: 155px;
  }
  .step__description {
    display: none;
  }
  .workflow-card {
    min-height: auto;
  }
  .action-footer {
    align-items: stretch;
    flex-direction: column;
  }
  .action-footer .btn {
    width: 100%;
  }
  .action-footer__hint {
    justify-content: center;
    text-align: center;
  }
  .confirm-dialog__actions {
    flex-direction: column;
  }
}
.upload-step {
  padding: 24px;
  background: #f5f7fb;
}
.section-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 24px;
}
.section-header__icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eef2ff;
  color: #253b80;
  font-size: 20px;
}
.section-header__content {
  flex: 1;
}
.section-header__content h3 {
  margin: 0 0 4px;
  font-size: 20px;
  font-weight: 700;
  color: #172033;
}
.section-header__content p {
  margin: 0;
  color: #667085;
  font-size: 13px;
}
.section-header__badge {
  padding: 8px 14px;
  border-radius: 20px;
  background: #eef2ff;
  color: #253b80;
  font-size: 12px;
  font-weight: 700;
}
.upload-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.7fr) minmax(320px, 0.9fr);
  gap: 20px;
  align-items: start;
}
.upload-layout__left,
.upload-layout__right {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.form-card {
  background: #fff;
  border: 1px solid #e4e7ec;
  border-radius: 16px;
  padding: 22px;
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.04);
}
.form-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 20px;
}
.form-card__header h4 {
  margin: 0 0 5px;
  font-size: 16px;
  font-weight: 700;
  color: #172033;
}
.form-card__header p {
  margin: 0;
  color: #667085;
  font-size: 12px;
  line-height: 1.5;
}
.required-badge {
  padding: 5px 9px;
  border-radius: 6px;
  background: #fff4ed;
  color: #c4320a;
  font-size: 11px;
  font-weight: 600;
}
.header-icon {
  color: #667085;
  font-size: 17px;
}
.upload-box {
  min-height: 220px;
  border: 1.5px dashed #cbd5e1;
  border-radius: 14px;
  background: #f8fafc;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 5px;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    transform 0.2s ease;
}
.upload-box:hover {
  border-color: #253b80;
  background: #f5f7ff;
}
.upload-box__icon {
  width: 58px;
  height: 58px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eef2ff;
  color: #253b80;
  font-size: 25px;
  margin-bottom: 14px;
}
.upload-box__icon.success {
  background: #ecfdf3;
  color: #16a34a;
}
.upload-box h4 {
  margin: 0 0 8px;
  color: #172033;
  font-size: 15px;
  font-weight: 700;
}
.upload-box p {
  margin: 0 0 8px;
  color: #667085;
  font-size: 13px;
}
.upload-box p span {
  color: #253b80;
  font-weight: 600;
}
.upload-box small {
  color: #98a2b3;
  font-size: 11px;
}
.upload-box.has-file {
  border-color: #86efac;
  background: #f0fdf4;
}
.selected-file {
  margin-top: 14px;
  padding: 12px 14px;
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.selected-file__left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.file-icon {
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #eef2ff;
  color: #253b80;
}
.file-details {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.file-details strong {
  color: #344054;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.file-details span {
  color: #98a2b3;
  font-size: 11px;
}
.icon-button {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: transparent;
}
.icon-button.danger {
  color: #d92d20;
}
.icon-button.danger:hover {
  background: #fef3f2;
}
.form-field {
  margin-bottom: 20px;
}
.form-field:last-child {
  margin-bottom: 0;
}
.form-field > label {
  display: block;
  margin-bottom: 8px;
  color: #344054;
  font-size: 13px;
  font-weight: 600;
}
.required {
  color: #d92d20;
}
.input-wrapper,
.select-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.input-wrapper i:first-child,
.select-wrapper i:first-child {
  position: absolute;
  left: 14px;
  color: #98a2b3;
  font-size: 15px;
  pointer-events: none;
}
.input-wrapper input,
.input-wrapper select,
.select-wrapper input,
.select-wrapper select {
  width: 100%;
  height: 44px;
  border: 1px solid #d0d5dd;
  border-radius: 9px;
  background: #fff;
  color: #344054;
  font-size: 13px;
  outline: none;
  transition: 0.2s ease;
}
.input-wrapper input:focus,
.input-wrapper select:focus,
.select-wrapper input:focus,
.select-wrapper select:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.08);
}
.input-wrapper input,
.select-wrapper input {
  padding: 0 14px 0 42px;
}
.input-wrapper select,
.select-wrapper select {
  appearance: none;
  padding: 0 40px 0 42px;
  cursor: pointer;
}
.input-wrapper .select-arrow,
.select-wrapper .select-arrow {
  position: absolute;
  right: 14px;
  color: #98a2b3;
  pointer-events: none;
}
textarea {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #d0d5dd;
  border-radius: 9px;
  resize: vertical;
  color: #344054;
  font-size: 13px;
  outline: none;
  font-family: inherit;
}
textarea:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.08);
}
.field-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
  color: #98a2b3;
  font-size: 11px;
}
.status-card {
  min-height: 72px;
  padding: 12px;
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f9fafb;
}
.status-card__content {
  display: flex;
  align-items: center;
  gap: 10px;
}
.status-card__content > div:last-child {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.status-card__content strong {
  color: #344054;
  font-size: 13px;
}
.status-card__content span {
  color: #667085;
  font-size: 11px;
}
.status-card__icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #ecfdf3;
  color: #16a34a;
}
.switch {
  position: relative;
  width: 42px;
  height: 23px;
  flex-shrink: 0;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.switch__slider {
  position: absolute;
  inset: 0;
  border-radius: 20px;
  background: #d0d5dd;
  cursor: pointer;
  transition: 0.2s;
}
.switch__slider::before {
  content: "";
  position: absolute;
  width: 17px;
  height: 17px;
  left: 3px;
  top: 3px;
  border-radius: 50%;
  background: #fff;
  transition: 0.2s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.switch input:checked + .switch__slider {
  background: #16a34a;
}
.switch input:checked + .switch__slider::before {
  transform: translateX(19px);
}
.summary-card {
  background:
    linear-gradient(
      180deg,
      #ffffff 0%,
      #fafbff 100%);
}
.summary-icon {
  color: #16a34a;
  font-size: 18px;
}
.summary-list {
  display: flex;
  flex-direction: column;
}
.summary-item {
  padding: 12px 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-bottom: 1px solid #eef0f4;
}
.summary-item:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}
.summary-item span {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #667085;
  font-size: 11px;
}
.summary-item span i {
  font-size: 12px;
}
.summary-item strong {
  color: #344054;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.summary-item strong.active {
  color: #16a34a;
}
.summary-item strong.inactive {
  color: #d92d20;
}
.next-step-card {
  padding: 16px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  border: 1px solid #dbe4ff;
  border-radius: 12px;
  background: #f5f7ff;
}
.next-step-card__icon {
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #253b80;
  color: #fff;
}
.next-step-card span {
  display: block;
  margin-bottom: 3px;
  color: #667085;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 700;
}
.next-step-card strong {
  display: block;
  margin-bottom: 4px;
  color: #253b80;
  font-size: 14px;
}
.next-step-card p {
  margin: 0;
  color: #667085;
  font-size: 11px;
  line-height: 1.5;
}
.action-footer {
  margin-top: 20px;
  padding: 16px 18px;
  background: #fff;
  border: 1px solid #e4e7ec;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
.action-footer__hint {
  display: flex;
  align-items: center;
  gap: 10px;
}
.action-footer__hint-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #eef2ff;
  color: #253b80;
}
.action-footer__hint strong,
.action-footer__hint span {
  display: block;
}
.action-footer__hint strong {
  margin-bottom: 3px;
  color: #344054;
  font-size: 12px;
}
.action-footer__hint span {
  color: #667085;
  font-size: 11px;
}
.continue-button {
  min-width: 170px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  border: 0;
  border-radius: 9px;
  background: #253b80;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
}
.continue-button:hover:not(:disabled) {
  background: #1d2f68;
  transform: translateY(-1px);
}
.continue-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
@media (max-width: 1000px) {
  .upload-layout {
    grid-template-columns: 1fr;
  }
  .upload-layout__right {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: start;
  }
  .next-step-card {
    grid-column: 1/-1;
  }
}
@media (max-width: 700px) {
  .upload-step {
    padding: 15px;
  }
  .section-header {
    align-items: flex-start;
  }
  .section-header__badge {
    display: none;
  }
  .upload-layout__right {
    display: flex;
  }
  .action-footer {
    flex-direction: column;
    align-items: stretch;
  }
  .continue-button {
    width: 100%;
  }
  .upload-box {
    min-height: 190px;
    padding: 20px;
  }
  .form-card {
    padding: 16px;
  }
}
.assessment-builder {
  padding: 24px;
}
.assessment-settings,
.questions-section {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  margin-top: 24px;
}
.assessment-settings {
  padding: 24px;
}
.settings-header {
  margin-bottom: 22px;
}
.settings-header h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
}
.settings-header p {
  margin: 5px 0 0;
  color: #6b7280;
  font-size: 13px;
}
.settings-grid {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr;
  gap: 22px;
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.form-group label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}
.form-group small {
  color: #6b7280;
  font-size: 12px;
}
.required {
  color: #dc2626;
}
.generation-options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.generation-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.2s;
}
.generation-card input {
  display: none;
}
.generation-card.active {
  border-color: #253b80;
  background: #f3f5fb;
}
.generation-card strong,
.generation-card span {
  display: block;
}
.generation-card strong {
  font-size: 13px;
}
.generation-card span {
  margin-top: 3px;
  color: #6b7280;
  font-size: 11px;
}
.generation-card__icon {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  background: #eef2ff;
  color: #253b80;
}
.percentage-input {
  display: flex;
  align-items: center;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  overflow: hidden;
}
.percentage-input input {
  width: 100%;
  border: 0;
  padding: 10px 12px;
  outline: none;
}
.percentage-input span {
  padding-right: 12px;
  color: #6b7280;
}
.retest-setting {
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.switch {
  position: relative;
  width: 44px;
  height: 24px;
  flex-shrink: 0;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.switch .slider {
  position: absolute;
  inset: 0;
  background: #d1d5db;
  border-radius: 20px;
  cursor: pointer;
  transition: 0.2s;
}
.switch .slider::before {
  content: "";
  position: absolute;
  width: 18px;
  height: 18px;
  left: 3px;
  top: 3px;
  background: #fff;
  border-radius: 50%;
  transition: 0.2s;
}
.switch input:checked + .slider {
  background: #253b80;
}
.switch input:checked + .slider::before {
  transform: translateX(20px);
}
.ai-generation {
  margin-top: 18px;
  padding: 18px;
  display: flex;
  align-items: center;
  gap: 15px;
  background: #f5f3ff;
  border: 1px solid #ddd6fe;
  border-radius: 12px;
}
.ai-generation__icon {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  background: #ede9fe;
  color: #6d28d9;
  border-radius: 10px;
}
.ai-generation__content {
  flex: 1;
}
.ai-generation__content h4 {
  margin: 0;
  font-size: 14px;
}
.ai-generation__content p {
  margin: 4px 0 0;
  color: #6b7280;
  font-size: 12px;
}
.ai-generation__actions {
  display: flex;
  gap: 10px;
}
.questions-section {
  padding: 24px;
}
.questions-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.questions-header h4 {
  margin: 0;
  font-size: 18px;
}
.questions-header p {
  margin: 4px 0 0;
  color: #6b7280;
  font-size: 12px;
}
.total-score {
  text-align: right;
}
.total-score span,
.total-score small {
  color: #6b7280;
  font-size: 12px;
}
.total-score strong {
  margin-left: 8px;
  font-size: 20px;
  color: #253b80;
}
.question-card {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  margin-bottom: 18px;
  overflow: hidden;
}
.question-card__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.question-number {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: #253b80;
  color: #fff;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
}
.question-title {
  flex: 1;
}
.question-title span {
  font-size: 12px;
  color: #6b7280;
}
.question-card > .form-group,
.options-section {
  padding: 18px;
}
.form-control {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  outline: none;
}
.form-control:focus {
  border-color: #253b80;
}
.question-input {
  resize: vertical;
}
.options-section {
  padding-top: 0;
}
.options-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.options-header label {
  font-size: 13px;
  font-weight: 600;
}
.options-header .hint {
  font-size: 11px;
  color: #6b7280;
}
.option-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-bottom: 8px;
}
.option-row.correct {
  border-color: #16a34a;
  background: #f0fdf4;
}
.answer-radio {
  cursor: pointer;
}
.answer-radio input {
  width: 16px;
  height: 16px;
  accent-color: #16a34a;
}
.option-letter {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  background: #f3f4f6;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
}
.option-row .form-control {
  flex: 1;
}
.icon-btn {
  border: 0;
  background: transparent;
  cursor: pointer;
}
.icon-btn.danger {
  color: #dc2626;
}
.add-option-btn,
.add-question-btn {
  border: 1px dashed #9ca3af;
  background: transparent;
  color: #253b80;
  padding: 9px 14px;
  border-radius: 8px;
  cursor: pointer;
}
.add-question-btn {
  width: 100%;
  margin-top: 5px;
  padding: 14px;
}
.question-card__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
}
.correct-answer-info {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #15803d;
  font-size: 12px;
}
.marks-input {
  display: flex;
  align-items: center;
  gap: 8px;
}
.marks-input label {
  font-size: 12px;
  font-weight: 600;
}
.marks-input input {
  width: 60px;
  padding: 7px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
}
.assessment-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
  padding: 18px 20px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
}
.assessment-summary {
  display: flex;
  gap: 28px;
}
.assessment-summary div {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.assessment-summary span {
  color: #6b7280;
  font-size: 11px;
}
.assessment-summary strong {
  color: #1f2937;
  font-size: 14px;
}
.btn-primary {
  background: #253b80;
  color: #fff;
  border: 0;
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
}
.btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn-ai {
  background: #6d28d9;
  color: #fff;
  border: 0;
  border-radius: 8px;
  padding: 10px 15px;
  cursor: pointer;
}
@media (max-width: 900px) {
  .settings-grid {
    grid-template-columns: 1fr;
  }
  .assessment-footer {
    flex-direction: column;
    align-items: stretch;
  }
  .assessment-summary {
    justify-content: space-between;
    gap: 10px;
  }
  .continue-btn {
    width: 100%;
  }
}
.assessment-step {
  width: 100%;
  min-width: 0;
  padding: 4px 2px 20px;
  box-sizing: border-box;
  color: #172033;
}
.assessment-step button,
.assessment-step input,
.assessment-step textarea,
.assessment-step select {
  font-family: inherit;
}
.assessment-step button {
  outline: none;
}
.assessment-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 18px;
}
.assessment-heading {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 12px;
}
.assessment-heading-icon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 11px;
  background: #eef2ff;
  color: #253b80;
  font-size: 18px;
}
.assessment-heading h2 {
  margin: 0;
  color: #172033;
  font-size: 19px;
  font-weight: 700;
  line-height: 1.3;
}
.assessment-heading p {
  margin: 4px 0 0;
  color: #7b8494;
  font-size: 12px;
  line-height: 1.5;
}
.assessment-count {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  flex-shrink: 0;
  padding: 7px 11px;
  border: 1px solid #e1e6ef;
  border-radius: 8px;
  background: #f8fafc;
  color: #566174;
  font-size: 11px;
  font-weight: 600;
}
.assessment-count i {
  color: #253b80;
  font-size: 12px;
}
.assessment-panel {
  margin-bottom: 16px;
  padding: 18px;
  border: 1px solid #e3e7ee;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.025);
}
.panel-heading {
  margin-bottom: 15px;
}
.panel-heading h3 {
  margin: 0;
  color: #202939;
  font-size: 14px;
  font-weight: 700;
}
.panel-heading p {
  margin: 4px 0 0;
  color: #8a93a2;
  font-size: 11px;
  line-height: 1.4;
}
.assessment-mode-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;
}
.mode-card {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  padding: 14px;
  border: 1px solid #e1e5eb;
  border-radius: 10px;
  background: #ffffff;
  text-align: left;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;
}
.mode-card:hover {
  border-color: #bdc7df;
  background: #fbfcff;
}
.mode-card:active {
  transform: translateY(1px);
}
.mode-card.active {
  border-color: #253b80;
  background: #f7f8ff;
  box-shadow: 0 0 0 2px rgba(37, 59, 128, 0.07);
}
.mode-card-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 11px;
  border-radius: 9px;
  font-size: 16px;
}
.mode-card-icon.manual {
  background: #eef2ff;
  color: #253b80;
}
.mode-card-icon.ai {
  background: #fff7ed;
  color: #ea580c;
}
.mode-card-content {
  min-width: 0;
  flex: 1;
}
.mode-card-content p {
  margin: 4px 0 0;
  color: #8a93a2;
  font-size: 10px;
  line-height: 1.45;
}
.mode-card-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.mode-card-title strong {
  min-width: 0;
  color: #253047;
  font-size: 12px;
  font-weight: 700;
}
.mode-radio {
  width: 19px;
  height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1.5px solid #cbd2dd;
  border-radius: 50%;
  background: #ffffff;
  color: #ffffff;
  transition: 0.2s;
}
.mode-radio i {
  font-size: 9px;
}
.mode-radio.checked {
  border-color: #253b80;
  background: #253b80;
}
.assessment-settings-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(180px, 0.8fr) minmax(180px, 0.8fr);
  gap: 12px;
}
.setting-box {
  min-width: 0;
  min-height: 68px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 12px;
  border: 1px solid #e7eaf0;
  border-radius: 9px;
  background: #fafbfc;
  box-sizing: border-box;
}
.setting-box-icon {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 8px;
  background: #eef2ff;
  color: #253b80;
  font-size: 13px;
}
.setting-box-content {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.setting-box-content strong,
.setting-box-content label {
  margin: 0;
  color: #374151;
  font-size: 11px;
  font-weight: 700;
}
.setting-box-content span {
  color: #9199a7;
  font-size: 9px;
  line-height: 1.35;
}
.input-box .setting-box-content {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.input-box input {
  width: 70px;
  height: 32px;
  padding: 5px 8px;
  border: 1px solid #dce1e8;
  border-radius: 7px;
  background: #ffffff;
  color: #253047;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  outline: none;
  transition: 0.2s;
}
.input-box input:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 2px rgba(37, 59, 128, 0.07);
}
.custom-switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;
  flex-shrink: 0;
  cursor: pointer;
}
.custom-switch input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
}
.switch-slider {
  position: absolute;
  inset: 0;
  border-radius: 999px;
  background: #d5d9e0;
  transition: 0.25s;
}
.switch-slider::before {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  left: 3px;
  top: 3px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
  transition: 0.25s;
}
.custom-switch input:checked + .switch-slider {
  background: #253b80;
}
.custom-switch input:checked + .switch-slider::before {
  transform: translateX(18px);
}
.questions-panel {
  overflow: hidden;
  border: 1px solid #e3e7ee;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.025);
}
.questions-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  padding: 15px 18px;
  border-bottom: 1px solid #e9ecf1;
  background: #fbfcfe;
}
.questions-heading {
  display: flex;
  align-items: center;
  gap: 10px;
}
.questions-heading-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 8px;
  background: #eef2ff;
  color: #253b80;
  font-size: 14px;
}
.questions-heading h3 {
  margin: 0;
  color: #202939;
  font-size: 13px;
  font-weight: 700;
}
.questions-heading p {
  margin: 3px 0 0;
  color: #8b94a3;
  font-size: 10px;
}
.total-marks {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border: 1px solid #e3e7ef;
  border-radius: 7px;
  background: #ffffff;
}
.total-marks span {
  color: #7d8797;
  font-size: 10px;
}
.total-marks strong {
  color: #253b80;
  font-size: 12px;
  font-weight: 700;
}
.questions-container {
  padding: 16px;
}
.question-editor {
  overflow: hidden;
  border: 1px solid #e0e5ec;
  border-radius: 10px;
  background: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.question-editor:hover {
  border-color: #d4dae4;
  box-shadow: 0 3px 12px rgba(15, 23, 42, 0.035);
}
.question-editor + .question-editor {
  margin-top: 14px;
}
.question-editor-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 54px;
  padding: 9px 13px;
  border-bottom: 1px solid #e9edf2;
  background: #f8fafc;
}
.question-title {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 9px;
}
.question-number {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 8px;
  background: #253b80;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
}
.question-title > div:last-child {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 2px;
}
.question-title > div:last-child strong {
  color: #263247;
  font-size: 11px;
  font-weight: 700;
}
.question-title > div:last-child span {
  color: #929aa8;
  font-size: 9px;
}
.question-header-actions {
  display: flex;
  align-items: center;
  gap: 7px;
  flex-shrink: 0;
}
.question-mark-badge {
  padding: 5px 8px;
  border-radius: 6px;
  background: #eef2ff;
  color: #253b80;
  font-size: 9px;
  font-weight: 700;
}
.question-delete {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #9aa2af;
  cursor: pointer;
  transition: 0.2s;
}
.question-delete:hover {
  background: #fef2f2;
  color: #dc2626;
}
.question-delete i {
  font-size: 11px;
}
.question-editor-body {
  padding: 17px;
}
.form-group {
  min-width: 0;
}
.form-group > label {
  display: block;
  margin-bottom: 7px;
  color: #374151;
  font-size: 10px;
  font-weight: 700;
}
.form-group > label span {
  color: #dc2626;
  margin-left: 2px;
}
.question-input {
  display: block;
  width: 100%;
  min-height: 76px;
  box-sizing: border-box;
  padding: 10px 11px;
  border: 1px solid #dfe4eb;
  border-radius: 8px;
  background: #ffffff;
  color: #273244;
  font-size: 11px;
  line-height: 1.55;
  resize: vertical;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.question-input::placeholder {
  color: #a1a8b3;
}
.question-input:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.06);
}
.question-settings {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 140px;
  gap: 12px;
  margin-top: 14px;
}
.select-field {
  position: relative;
}
.select-field select {
  appearance: none;
  width: 100%;
  height: 37px;
  padding: 0 32px 0 10px;
  border: 1px solid #dfe4eb;
  border-radius: 7px;
  background: #ffffff;
  color: #374151;
  font-size: 11px;
  outline: none;
  cursor: pointer;
}
.select-field select:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.06);
}
.select-field > i {
  position: absolute;
  right: 11px;
  top: 50%;
  transform: translateY(-50%);
  color: #8b94a3;
  font-size: 9px;
  pointer-events: none;
}
.marks-input {
  position: relative;
}
.marks-input i {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #8b94a3;
  font-size: 10px;
  pointer-events: none;
}
.marks-input input {
  width: 100%;
  height: 37px;
  box-sizing: border-box;
  padding: 0 9px 0 29px;
  border: 1px solid #dfe4eb;
  border-radius: 7px;
  background: #ffffff;
  color: #374151;
  font-size: 11px;
  outline: none;
}
.marks-input input:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.06);
}
.answers-section {
  margin-top: 18px;
  padding-top: 17px;
  border-top: 1px solid #edf0f4;
}
.answers-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 10px;
}
.answers-header label {
  display: block;
  margin-bottom: 3px;
  color: #374151;
  font-size: 10px;
  font-weight: 700;
}
.answers-header label span {
  color: #dc2626;
}
.answers-header small {
  color: #9aa2ae;
  font-size: 9px;
}
.answers-header > span {
  flex-shrink: 0;
  padding: 5px 8px;
  border-radius: 5px;
  background: #f3f4f6;
  color: #727b89;
  font-size: 9px;
  font-weight: 600;
}
.answer-list {
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.answer-item {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 8px;
  min-height: 43px;
  padding: 4px 7px;
  box-sizing: border-box;
  border: 1px solid #e1e5eb;
  border-radius: 8px;
  background: #ffffff;
  transition: border-color 0.2s ease, background 0.2s ease;
}
.answer-item:hover {
  border-color: #cdd4df;
}
.answer-item.correct {
  border-color: #b8d9c3;
  background: #f7fcf8;
}
.answer-selector {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}
.answer-selector span {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border: 1.5px solid #c9d0da;
  background: #ffffff;
  color: #ffffff;
  transition: 0.2s;
}
.answer-selector i {
  font-size: 8px;
}
.answer-selector.radio span {
  border-radius: 50%;
}
.answer-selector.radio.selected span {
  border-color: #16a34a;
  background: #16a34a;
}
.answer-selector.checkbox span {
  border-radius: 4px;
}
.answer-selector.checkbox.selected span {
  border-color: #16a34a;
  background: #16a34a;
}
.answer-letter {
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 6px;
  background: #f1f3f7;
  color: #667085;
  font-size: 9px;
  font-weight: 700;
}
.answer-input {
  min-width: 0;
  flex: 1;
  height: 34px;
  padding: 0 8px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  color: #344054;
  font-size: 11px;
  outline: none;
}
.answer-input:hover {
  background: #fafafa;
}
.answer-input:focus {
  border-color: #dce1e8;
  background: #ffffff;
  box-shadow: 0 0 0 2px rgba(37, 59, 128, 0.04);
}
.answer-input::placeholder {
  color: #a3aab5;
}
.correct-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  padding: 5px 7px;
  border-radius: 5px;
  background: #dcfce7;
  color: #15803d;
  font-size: 8px;
  font-weight: 700;
}
.correct-label i {
  font-size: 9px;
}
.answer-delete {
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  transition: 0.2s;
}
.answer-delete:hover {
  background: #fef2f2;
  color: #dc2626;
}
.answer-delete i {
  font-size: 10px;
}
.add-choice {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  padding: 7px 10px;
  border: 1px dashed #bfc7d5;
  border-radius: 6px;
  background: #fafbff;
  color: #253b80;
  font-size: 9px;
  font-weight: 700;
  cursor: pointer;
  transition: 0.2s;
}
.add-choice:hover {
  border-color: #253b80;
  background: #f4f6ff;
}
.add-choice i {
  font-size: 9px;
}
.add-question {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 14px;
  padding: 13px;
  border: 1px dashed #b9c3d3;
  border-radius: 9px;
  background: #fafbff;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;
}
.add-question:hover {
  border-color: #253b80;
  background: #f5f7ff;
}
.add-question-icon {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 10px;
  border-radius: 8px;
  background: #eef2ff;
  color: #253b80;
  font-size: 13px;
}
.add-question-content {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.add-question-content strong {
  color: #253b80;
  font-size: 11px;
  font-weight: 700;
}
.add-question-content small {
  color: #8d96a5;
  font-size: 9px;
}
.add-question-arrow {
  margin-left: auto;
  color: #8b95a5;
  font-size: 10px;
}
.assessment-actions {
  position: sticky;
  bottom: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin-top: 16px;
  padding: 12px 14px;
  border: 1px solid #e0e5ec;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0 -3px 12px rgba(15, 23, 42, 0.04);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
}
.assessment-help {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 7px;
  color: #7b8493;
  font-size: 9px;
}
.assessment-help i {
  color: #253b80;
  font-size: 12px;
}
.assessment-help span {
  white-space: nowrap;
}
.assessment-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.btn-primary,
.btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 36px;
  padding: 7px 13px;
  border-radius: 7px;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.15s ease;
}
.btn-primary i,
.btn-secondary i {
  font-size: 10px;
}
.btn-primary:active,
.btn-secondary:active {
  transform: translateY(1px);
}
.btn-primary {
  border: 1px solid #253b80;
  background: #253b80;
  color: #ffffff;
}
.btn-primary:hover {
  border-color: #1d2f68;
  background: #1d2f68;
  box-shadow: 0 4px 10px rgba(37, 59, 128, 0.18);
}
.btn-secondary {
  border: 1px solid #d4dae3;
  background: #ffffff;
  color: #344054;
}
.btn-secondary:hover {
  border-color: #253b80;
  color: #253b80;
  background: #f7f8ff;
}
:host ::ng-deep .document-review-dialog .p-dialog-content {
  padding: 0 !important;
  overflow-x: hidden !important;
}
@media (max-width: 1100px) {
  .assessment-settings-grid {
    grid-template-columns: minmax(0, 1fr) minmax(160px, 0.7fr) minmax(160px, 0.7fr);
  }
  .setting-box {
    padding: 10px;
  }
}
@media (max-width: 850px) {
  .assessment-page-header {
    align-items: flex-start;
  }
  .assessment-mode-grid {
    grid-template-columns: 1fr;
  }
  .assessment-settings-grid {
    grid-template-columns: 1fr 1fr;
  }
  .setting-box:first-child {
    grid-column: 1/-1;
  }
  .assessment-actions {
    align-items: flex-start;
    flex-direction: column;
  }
  .assessment-help {
    width: 100%;
  }
  .assessment-buttons {
    width: 100%;
    justify-content: flex-end;
  }
}
@media (max-width: 650px) {
  .assessment-step {
    padding: 0 0 15px;
  }
  .assessment-page-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .assessment-count {
    align-self: flex-start;
  }
  .assessment-panel {
    padding: 13px;
  }
  .assessment-settings-grid {
    grid-template-columns: 1fr;
  }
  .setting-box:first-child {
    grid-column: auto;
  }
  .question-settings {
    grid-template-columns: 1fr;
  }
  .questions-container {
    padding: 10px;
  }
  .question-editor-body {
    padding: 13px;
  }
  .questions-panel-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .total-marks {
    align-self: flex-start;
  }
  .assessment-actions {
    padding: 10px;
  }
  .assessment-buttons {
    width: 100%;
    flex-direction: column;
  }
  .assessment-buttons .btn-primary,
  .assessment-buttons .btn-secondary {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .assessment-heading-icon {
    width: 38px;
    height: 38px;
    font-size: 15px;
  }
  .assessment-heading h2 {
    font-size: 16px;
  }
  .assessment-heading p {
    font-size: 10px;
  }
  .mode-card {
    padding: 11px;
  }
  .mode-card-icon {
    width: 35px;
    height: 35px;
    margin-right: 8px;
    font-size: 14px;
  }
  .question-editor-header {
    padding: 8px 10px;
  }
  .question-editor-body {
    padding: 11px;
  }
  .question-title > div:last-child span {
    display: none;
  }
  .question-mark-badge {
    display: none;
  }
  .answer-item {
    gap: 5px;
  }
  .answer-letter {
    width: 22px;
    height: 22px;
  }
  .answer-input {
    font-size: 10px;
  }
  .correct-label {
    display: none;
  }
  .assessment-help span {
    white-space: normal;
  }
}
.survey-step {
  width: 100%;
}
.section-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 28px;
}
.section-header__icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.section-header__icon.survey {
  background: #f3e8ff;
  color: #7c3aed;
}
.section-header__content h3 {
  margin: 0;
  color: #1f2937;
  font-size: 20px;
  font-weight: 700;
}
.section-header__content p {
  margin: 4px 0 0;
  color: #6b7280;
  font-size: 14px;
}
.survey-empty {
  min-height: 400px;
  border: 1px dashed #d7dce5;
  border-radius: 16px;
  background: #fafbfc;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 30px;
  text-align: center;
}
.survey-empty__icon {
  width: 76px;
  height: 76px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3e8ff;
  color: #7c3aed;
  font-size: 30px;
  margin-bottom: 20px;
}
.survey-empty h3 {
  margin: 0 0 8px;
  color: #1f2937;
  font-size: 20px;
  font-weight: 700;
}
.survey-empty p {
  max-width: 500px;
  margin: 0 0 24px;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.6;
}
.survey-empty__button {
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0 20px;
}
.survey-builder {
  width: 100%;
}
.survey-builder__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: #fff;
}
.survey-builder__top h4 {
  margin: 0;
  color: #1f2937;
  font-size: 17px;
  font-weight: 700;
}
.survey-builder__top p {
  margin: 5px 0 0;
  color: #6b7280;
  font-size: 13px;
}
.survey-count {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 13px;
  border-radius: 20px;
  background: #f3f4f6;
  color: #4b5563;
  font-size: 13px;
  font-weight: 600;
}
.survey-count i {
  color: #7c3aed;
}
.survey-questions {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.question-card {
  overflow: hidden;
  border: 1px solid #e2e6ed;
  border-radius: 14px;
  background: #fff;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}
.question-card:hover {
  border-color: #cfd5df;
  box-shadow: 0 6px 20px rgba(31, 41, 55, 0.06);
}
.question-card__header {
  min-height: 66px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 18px;
  background: #f8f9fc;
  border-bottom: 1px solid #e8ebf0;
}
.question-number {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #253b80;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
}
.question-title {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1;
}
.question-title span {
  color: #1f2937;
  font-size: 14px;
  font-weight: 700;
}
.question-title small {
  color: #9ca3af;
  font-size: 12px;
}
.question-delete {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s ease;
}
.question-delete:hover {
  background: #fee2e2;
  color: #dc2626;
}
.question-card__body {
  padding: 22px;
}
.form-group {
  margin-bottom: 24px;
}
.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #374151;
  font-size: 13px;
  font-weight: 600;
}
.form-group .required {
  color: #dc2626;
}
.form-control {
  width: 100%;
  min-height: 44px;
  padding: 10px 13px;
  border: 1px solid #d7dce5;
  border-radius: 9px;
  background: #fff;
  color: #1f2937;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.form-control::placeholder {
  color: #9ca3af;
}
.form-control:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.08);
}
.choices-section {
  border-top: 1px solid #eef0f4;
  padding-top: 20px;
}
.choices-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}
.choices-header label {
  display: block;
  margin-bottom: 3px;
  color: #374151;
  font-size: 13px;
  font-weight: 600;
}
.choices-header small {
  color: #9ca3af;
  font-size: 12px;
}
.choices-header .required {
  color: #dc2626;
}
.choices-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.choice-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.choice-index {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f3f4f6;
  color: #6b7280;
  font-size: 12px;
  font-weight: 600;
}
.choice-input {
  flex: 1;
}
.choice-remove {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  background: #f9fafb;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s ease;
}
.choice-remove:hover {
  background: #fee2e2;
  color: #dc2626;
}
.add-choice-btn {
  margin-top: 14px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 12px;
  border: 1px dashed #cbd2df;
  border-radius: 8px;
  background: #fafbfc;
  color: #253b80;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.add-choice-btn:hover {
  border-color: #253b80;
  background: #f4f6fb;
}
.add-choice-btn i {
  font-size: 12px;
}
.add-question-btn {
  width: 100%;
  margin-top: 18px;
  padding: 15px 18px;
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px dashed #b9c2d4;
  border-radius: 12px;
  background: #fafbfc;
  color: #253b80;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
}
.add-question-btn:hover {
  border-color: #253b80;
  background: #f4f6fb;
  transform: translateY(-1px);
}
.add-question-btn__icon {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #e9edf8;
  color: #253b80;
}
.add-question-btn span:nth-child(2) {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.add-question-btn strong {
  font-size: 13px;
  font-weight: 700;
}
.add-question-btn small {
  color: #8b95a5;
  font-size: 11px;
}
.add-question-btn > i {
  color: #9ca3af;
}
.survey-footer {
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
}
.survey-footer__right {
  display: flex;
  align-items: center;
  gap: 10px;
}
.btn {
  min-height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.btn-primary {
  border: 1px solid #253b80;
  background: #253b80;
  color: #fff;
}
.btn-primary:hover {
  background: #1d2f68;
  border-color: #1d2f68;
}
.btn-outline-primary {
  border: 1px solid #253b80;
  background: #fff;
  color: #253b80;
}
.btn-outline-primary:hover {
  background: #f4f6fb;
}
.btn-outline-secondary {
  border: 1px solid #d7dce5;
  background: #fff;
  color: #4b5563;
}
.btn-outline-secondary:hover {
  background: #f9fafb;
  border-color: #c5cad4;
}
@media (max-width: 768px) {
  .survey-builder__top {
    align-items: flex-start;
    flex-direction: column;
  }
  .question-card__body {
    padding: 16px;
  }
  .survey-footer {
    flex-direction: column;
    align-items: stretch;
  }
  .survey-footer__right {
    width: 100%;
    flex-direction: column;
  }
  .survey-footer__right .btn {
    width: 100%;
  }
  .survey-footer > .btn {
    width: 100%;
  }
  .choice-row {
    align-items: flex-start;
  }
  .choice-index {
    margin-top: 7px;
  }
  .choice-remove {
    margin-top: 4px;
  }
}
.poll-step {
  width: 100%;
}
.section-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 28px;
}
.section-header__icon {
  width: 46px;
  height: 46px;
  min-width: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 20px;
}
.section-header__icon.poll {
  color: #7c3aed;
  background: #f3e8ff;
}
.section-header__content h3 {
  margin: 0 0 4px;
  color: #172033;
  font-size: 20px;
  font-weight: 700;
}
.section-header__content p {
  margin: 0;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.5;
}
.empty-step {
  min-height: 340px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 50px 25px;
  border: 1px dashed #d6dbe5;
  border-radius: 16px;
  background: #fafbfc;
  text-align: center;
}
.empty-step__icon {
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  border-radius: 18px;
  color: #7c3aed;
  background: #f3e8ff;
  font-size: 28px;
}
.empty-step h3 {
  margin: 0 0 8px;
  color: #1f2937;
  font-size: 20px;
  font-weight: 700;
}
.empty-step p {
  max-width: 500px;
  margin: 0 0 24px;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.6;
}
.btn {
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 18px;
  border: 1px solid transparent;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;
}
.btn i {
  font-size: 14px;
}
.btn:active {
  transform: translateY(1px);
}
.btn-primary {
  color: #fff;
  background: #253b80;
  border-color: #253b80;
}
.btn-primary:hover {
  background: #1d2f68;
  border-color: #1d2f68;
  box-shadow: 0 4px 12px rgba(37, 59, 128, 0.18);
}
.btn-outline-primary {
  color: #253b80;
  background: #fff;
  border-color: #cbd5e1;
}
.btn-outline-primary:hover {
  color: #1d2f68;
  background: #f5f7ff;
  border-color: #253b80;
}
.btn-light {
  color: #475569;
  background: #f8fafc;
  border-color: #e2e8f0;
}
.btn-light:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
}
.poll-builder {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.poll-builder__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
}
.poll-builder__top h3 {
  margin: 0 0 4px;
  color: #172033;
  font-size: 17px;
  font-weight: 700;
}
.poll-builder__top p {
  margin: 0;
  color: #6b7280;
  font-size: 13px;
}
.poll-question-card {
  padding: 22px;
  border: 1px solid #e3e7ef;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.03);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.poll-question-card:hover {
  border-color: #d6dbea;
  box-shadow: 0 5px 16px rgba(15, 23, 42, 0.05);
}
.poll-question-card__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 18px;
  margin-bottom: 20px;
  border-bottom: 1px solid #edf0f4;
}
.question-number {
  width: 34px;
  height: 34px;
  min-width: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  color: #253b80;
  background: #eef2ff;
  font-size: 13px;
  font-weight: 700;
}
.question-title {
  flex: 1;
}
.question-title h4 {
  margin: 0 0 3px;
  color: #1f2937;
  font-size: 15px;
  font-weight: 700;
}
.question-title span {
  color: #8a94a6;
  font-size: 12px;
}
.poll-form-group {
  margin-bottom: 24px;
}
.poll-form-group label {
  display: block;
  margin-bottom: 8px;
  color: #374151;
  font-size: 13px;
  font-weight: 600;
}
.required {
  color: #dc2626;
}
.poll-input {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #d9dee8;
  border-radius: 8px;
  outline: none;
  color: #1f2937;
  background: #fff;
  font-family: inherit;
  font-size: 14px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.poll-input::placeholder {
  color: #a1a9b8;
}
.poll-input:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.08);
}
.poll-question-input {
  display: block;
  min-height: 90px;
  padding: 12px 14px;
  resize: vertical;
  line-height: 1.5;
}
.input-hint {
  margin-top: 6px;
  color: #8a94a6;
  font-size: 12px;
}
.choices-section {
  padding: 18px;
  border: 1px solid #edf0f4;
  border-radius: 10px;
  background: #fafbfc;
}
.choices-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}
.choices-section__header label {
  display: inline-block;
  margin: 0;
  color: #374151;
  font-size: 13px;
  font-weight: 600;
}
.choice-count {
  margin-left: 8px;
  color: #8a94a6;
  font-size: 12px;
}
.add-choice-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border: 0;
  border-radius: 6px;
  color: #253b80;
  background: #eef2ff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.add-choice-button:hover {
  background: #e0e7ff;
}
.add-choice-button i {
  font-size: 11px;
}
.choice-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.choice-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.choice-indicator {
  width: 32px;
  height: 32px;
  min-width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d9dee8;
  border-radius: 7px;
  color: #475569;
  background: #fff;
  font-size: 12px;
  font-weight: 700;
}
.choice-input {
  flex: 1;
  height: 40px;
  padding: 0 12px;
}
.choices-info {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  color: #8a94a6;
  font-size: 11px;
}
.choices-info i {
  font-size: 12px;
}
.icon-button {
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e6ed;
  border-radius: 7px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
}
.icon-button i {
  font-size: 13px;
}
.icon-button.danger {
  color: #dc2626;
}
.icon-button.danger:hover {
  background: #fef2f2;
  border-color: #fecaca;
}
.icon-button.danger:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
.icon-button.danger:disabled:hover {
  background: #fff;
  border-color: #e2e6ed;
}
.add-question-card {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  color: #475569;
  background: #fafbfc;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
}
.add-question-card:hover {
  border-color: #253b80;
  background: #f5f7ff;
}
.add-question-card:hover .add-question-card__icon {
  background: #253b80;
  color: #fff;
}
.add-question-card__icon {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  color: #253b80;
  background: #eef2ff;
  transition: all 0.2s ease;
}
.add-question-card span:nth-child(2) {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.add-question-card span:nth-child(2) strong {
  color: #334155;
  font-size: 13px;
  font-weight: 600;
}
.add-question-card span:nth-child(2) small {
  color: #94a3b8;
  font-size: 11px;
}
.add-question-card > i {
  color: #94a3b8;
  font-size: 13px;
}
.step-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}
.step-footer__right {
  display: flex;
  align-items: center;
  gap: 10px;
}
@media (max-width: 768px) {
  .poll-builder__top {
    align-items: flex-start;
    flex-direction: column;
    gap: 14px;
  }
  .poll-builder__top .btn {
    width: 100%;
  }
  .poll-question-card {
    padding: 16px;
  }
  .choices-section__header {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }
  .add-choice-button {
    width: 100%;
    justify-content: center;
  }
  .step-footer {
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
  }
  .step-footer__right {
    width: 100%;
    flex-direction: column;
  }
  .step-footer .btn {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .section-header {
    align-items: flex-start;
  }
  .section-header__icon {
    width: 40px;
    height: 40px;
    min-width: 40px;
  }
  .empty-step {
    min-height: 300px;
    padding: 30px 18px;
  }
  .poll-question-card__header {
    align-items: flex-start;
  }
  .choice-row {
    gap: 6px;
  }
  .choice-indicator {
    width: 28px;
    min-width: 28px;
    height: 28px;
  }
  .choice-row .icon-button {
    width: 32px;
    min-width: 32px;
  }
}
/*# sourceMappingURL=document-upload.component.css.map */
